define('components/trackingbridge/TrackingBridge', [

], function() {

    // var apiReady = false;
    // var bufferTag = [];
    var config;
    var tagPlan;
    var api;

    /*
     * Initialize Tracking Bridge
     * -> config (should contain environment)
     * -> tagPlan (corelation array with tagId and tagObject see config.tracking for more information)
     * -> api (dataLayer for now only)
     */
    var initialize = function (options) {
        if (options.config && options.tagPlan && options.api) {
            config = options.config;
            tagPlan = options.tagPlan;
            api = options.api;
        } else {
            console.warn("[TrackingBridge -> initialize] config, tagPlan or api undefined", options);
        }
    };

    /*
     * Replace key with obj in tagObj
     * /!\ key should be lowercase !!
     */
    var loopReplace = function (obj, replaceObj) {
        var replacedObj = {};

        if( !replaceObj ){
            replacedObj = obj;
        } else {
            var replaceExp = new RegExp(Object.keys(replaceObj).join("|"), "gi");
            var replaceMatch = function (matches) {
                return replaceObj[matches.toLowerCase()];
            };

            for (var key in obj) {
                replacedObj[key] = obj[key].replace(replaceExp, replaceMatch);
            }
        }

        return replacedObj;
    };

    /*
     * Function to track event
     * -> tagId (key in the tagPlan)
     * -> obj ( key, value ) to replace in tagPlan
     */
    var trackEvent = function (tagId, replaceObj) {

        var tracking = {};

        if (tagId && tagPlan[tagId]) {
            tracking = loopReplace(tagPlan[tagId], replaceObj);
        } else {
            console.warn("[TrackingBridge -> trackEvent] tagId undefined or unknown:", tagId);
            return;
        }

        trackObj( tracking, tagId );
    };

    var trackObj = function( tracking, tagId ) {
        if (config.environement === "development") {
            console.log("%c[TrackingBridge -> trackEvent] tracking:", "color: DeepPink;", tagId, tracking);
        } else {
            //TODO if !apiReady => faire une pile de tag à exécuter qd apiReady !
            // if (!apiReady) {
            //     bufferTag.push(tracking);
            // }

            switch (api) {
                case "dataLayer":
                    if( typeof dataLayer !== 'undefined' ) {
                        dataLayer.push(tracking);
                    } else {
                        console.warn("[TrackingBridge -> trackEvent] dataLayer undefined");
                    }
                    break;

                default:
                    console.warn("[TrackingBridge -> trackEvent] Tracking api unknown:", api, tracking);
                    break;
            }
        }
    };

    return {
        initialize: initialize,
        trackEvent: trackEvent,
        trackObj: trackObj
    };
});
